import { defineStore } from "pinia";
import { ref, computed } from "vue";
import cookie from "@/utilities/cookie.js";

export const usePostLoginAnnouncement = defineStore(
  "postLoginAnnouncement",
  () => {
    const postLoginAnnouncementQuery = ref(null);
    const activated = ref(false);
    const templateOrder = ref([]);
    const postLoginAnnouncementData = ref([]);
    const allPostLoginModal = ref(null);
    const postLoginModal = ref(null);

    const modalShown = ref(!!cookie.getSecureCookie("SLPU"));
    const markAsShown = () => {
      cookie.setSecureCookie("SLPU", "true", true, true, true, 86400);
      modalShown.value = true;
    };

    const popupTimestamp = ref(null);
    const selectedPostLogin = ref({
      id: null,
      announcementStartDate: null,
      headline: "",
      content: [],
      mainButtonName: "",
      mainButtonUrl: "",
      secondaryButtonName: "",
      secondaryButtonUrl: "",
      urlToggle: false,
      imageUrl: "",
      descriptionLinkUrl: "",
      descriptionLinkText: "",
      enabledClose: false,
    });

    const hasNotSeenAnnouncement = computed(() => {
      return postLoginAnnouncementData.value.some((item) => !item.seen);
    });

    const bellCallout = ref(false);
    const triggerBellCallout = () => {
      bellCallout.value = false;
      requestAnimationFrame(() => {
        bellCallout.value = true;
      });
    };

    const sendModalToBell = (
      modalId,
      onDone,
      { bellId = "notificationBellIcon", anchorX = 0.8, anchorY = 0.2 } = {}
    ) => {
      const modalEl = document.querySelector(`#${modalId} .modal-content`);
      const bellEl = document.getElementById(bellId);

      if (!modalEl || !bellEl) {
        onDone();
        return;
      }

      const modalRect = modalEl.getBoundingClientRect();
      const bellRect = bellEl.getBoundingClientRect();

      const targetX = bellRect.left + bellRect.width * anchorX;
      const targetY = bellRect.top + bellRect.height * anchorY;

      const dx = targetX - (modalRect.left + modalRect.width / 2);
      const dy = targetY - (modalRect.top + modalRect.height / 2);
      const scale = Math.max(bellRect.width / modalRect.width, 0.03);

      modalEl.style.transformOrigin = "center center";
      modalEl.style.transition =
        "transform 0.45s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s ease-in";
      void modalEl.offsetHeight;

      requestAnimationFrame(() => {
        modalEl.style.transform = `translate(${dx}px, ${dy}px) scale(${scale})`;
        modalEl.style.opacity = "0";
      });

      setTimeout(() => {
        onDone();
        modalEl.style.transition = "";
        modalEl.style.transform = "";
        modalEl.style.opacity = "";
        modalEl.style.transformOrigin = "";
      }, 450);
    };

    return {
      postLoginAnnouncementQuery,
      activated,
      templateOrder,
      postLoginAnnouncementData,
      allPostLoginModal,
      postLoginModal,
      modalShown,
      markAsShown,
      popupTimestamp,
      selectedPostLogin,
      hasNotSeenAnnouncement,
      bellCallout,
      triggerBellCallout,
      sendModalToBell,
    };
  }
);
